import classNames from 'classnames'
import { ForwardedRef, forwardRef, useEffect, useState } from 'react'

import { TablelistLogoProps } from 'types/ui/logo'

const drawDuration = 1000
export const tablePath =
  'M16 41.8467V59.0057H32V85.0467H48V59.0019L80 59.0057V85.0467H96V60.5116C96 59.6799 96.6742 59.0057 97.5059 59.0057H112V41.8467H16Z'

export const TablelistLogo = forwardRef(function TablelistLogo(
  {
    fill = 'black',
    className = 'w-20 h-20',
    draw = false,
    pingOnClick = true,
  }: TablelistLogoProps,
  ref: ForwardedRef<SVGSVGElement>
) {
  const [showBackground, setShowBackground] = useState(!draw)

  useEffect(() => {
    if (draw) {
      // scale out the background after drawing the logo
      setTimeout(() => {
        setShowBackground(true)
      }, drawDuration)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <svg
      viewBox='0 0 128 128'
      color={fill}
      stroke={fill}
      fill={fill}
      ref={ref}
      className={classNames('aspect-square overflow-visible', className)}
    >
      <path
        d={tablePath}
        className={classNames(
          'origin-center transition-colors ease-out duration-500',
          {
            'animate-draw-in': draw,
            'stroke-current': true,
            // 'stroke-current': !showBackground
          }
        )}
        strokeLinecap='round'
        strokeWidth={6}
        style={{ strokeDasharray: 1000 }}
        fill='none'
      />
      <path
        d={tablePath}
        strokeWidth={0}
        className={classNames(
          'origin-center transition-[fill] ease-out duration-500',
          {
            'fill-transparent': !showBackground,
            'fill-current': showBackground,
          }
        )}
      />
    </svg>
  )
})
